var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.57 54.59"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.78 54.59a1 1 0 01-.63-.22L.38 39.35a1 1 0 111.25-1.56l17.15 13.72V1a1 1 0 012 0v50.51l17.16-13.72a1 1 0 011.41.15 1 1 0 01-.16 1.41l-18.78 15a1 1 0 01-.63.24z",
    "data-name": "Layer 1"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOS41NyA1NC41OSI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iYXJyb3ctbGVmdCI+PHBhdGggZD0iTTE5Ljc4LDU0LjU5YTEsMSwwLDAsMS0uNjMtLjIyTC4zOCwzOS4zNWExLDEsMCwxLDEsMS4yNS0xLjU2TDE4Ljc4LDUxLjUxVjFhMSwxLDAsMCwxLDIsMFY1MS41MUwzNy45NCwzNy43OWExLDEsMCwwLDEsMS40MS4xNSwxLDEsMCwwLDEtLjE2LDEuNDFsLTE4Ljc4LDE1QTEsMSwwLDAsMSwxOS43OCw1NC41OVoiLz48L2c+PC9nPjwvZz48L3N2Zz4=";
export { SvgArrowDown as ReactComponent };